import React from "react";
import constants from "~/utils/constants";
import { CHILDREN_COUNT_FIELD } from "./constants";
import {
  Seniors,
  Adults,
  Teenagers,
  Children,
  Babies,
  PersonIcon,
  BabyCarriageIcon,
} from "~/theme/assets";
import styles from "./BookingForm.scss";
import classnames from "classnames";

function OccupantIcon({ type, ...props }) {
  const { className, ...otherProps } = props;

  switch (type) {
    case constants.OCCUPANTS_TYPE.SENIOR:
      return <PersonIcon />;
    case constants.OCCUPANTS_TYPE.ADULT:
      return <PersonIcon />;
    case constants.OCCUPANTS_TYPE.TEENAGER:
      return <PersonIcon />;
    case constants.OCCUPANTS_TYPE.CHILDREN:
      return <PersonIcon />;
    case constants.OCCUPANTS_TYPE.BABY:
      return <BabyCarriageIcon {...props} />;
    case CHILDREN_COUNT_FIELD:
      return <PersonIcon />;
    default:
      return <PersonIcon />;
  }
}
function GuestAgeRange({ minAge, maxAge, className }) {
  return maxAge === 999 ? (
    <span className={classnames(className, styles.guestAgeSingle)}>+{minAge}</span>
  ) : (
    <span className={classnames(className, styles.guestAgeRange)}>
      {minAge}-{maxAge}
    </span>
  );
}

export default function OccupantTypeSelector({
  field,
  occupantRange,
  minAge,
  maxAge,
  disabled,
  onChange,
  value: fieldValue,
  hideIcon,
}) {
  return (
    <div key={field.name} className={styles.selectorContainer}>
      {!hideIcon && (
        <div className={classnames(styles.occupantIcon, styles[field.name.toLowerCase()])}>
          {minAge !== null && maxAge !== null && (
            <GuestAgeRange className="guestAge" minAge={minAge} maxAge={maxAge} />
          )}
          <OccupantIcon type={field.name} />
        </div>
      )}
      <select
        {...field}
        onChange={onChange ? onChange : field.onChange}
        value={fieldValue || fieldValue === 0 ? fieldValue : field.value}
        className={styles.selector}
        disabled={disabled}>
        {occupantRange.map(value => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
}
